import { render, staticRenderFns } from "./FinanceAnalyze.vue?vue&type=template&id=64a87b36&scoped=true"
import script from "./FinanceAnalyze.vue?vue&type=script&lang=js"
export * from "./FinanceAnalyze.vue?vue&type=script&lang=js"
import style0 from "./FinanceAnalyze.vue?vue&type=style&index=0&id=64a87b36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a87b36",
  null
  
)

export default component.exports